"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function TagList(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      collapsible = _useState2[0],
      setCollapsible = _useState2[1];

  var tagListInnerRef = /*#__PURE__*/(0, _react.createRef)(); // This is our event listener (listens to all react events)

  (0, _react.useEffect)(function () {
    // If the inner hidden list is taller than one row
    if (tagListInnerRef.current.clientHeight > 29) {
      // Allow ability to expand list
      setCollapsible(true);
    } else {
      // Disable ability to expand list and close list
      setCollapsible(false);
      setIsOpen(false);
    }
  }, [tagListInnerRef] // Only listen to changes to tagListInnerRef
  );
  var caretState = isOpen === true ? 'up' : 'down';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-list"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-list__overflow " + (isOpen ? 'open' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-list__inner",
    ref: tagListInnerRef
  }, children)), collapsible && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-list__button-container"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "tag-list__button",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    link: true,
    name: "caret " + caretState,
    size: "large"
  }), isOpen ? 'Show Less' : 'Show More')));
}

var _default = TagList;
exports["default"] = _default;